import { NavigationItemNode } from '@/app/platform/platform-shared/navigation-item-tree/navigation-item-dragger';
import { InjectionToken } from '@angular/core';
import { NavigationItemData } from '@/app/platform/platform-shared/models/navigation-item.data';

export interface MatFlatTreeConfig<TSource, TNode extends FlatNode> {
  getLevel: (node: TNode) => number;
  isExpandable: (node: TNode) => boolean;
  getChildren: (node: TSource) => TSource[];
  hasChild: (_: number, node: TNode) => boolean;
  hasNoContent: (_: number, node: TNode) => boolean;
  transformer: (source: TSource, level: number) => TNode;
}

export const NAVIGATION_ITEM_FLAT_TREE_CONFIG = new InjectionToken<NavigationItemFlatTreeConfig>(
  ''
);

export interface NavigationItemFlatTreeConfig<T extends NavigationItemData = NavigationItemData>
  extends MatFlatTreeConfig<T, NavigationItemNode<T>> {}

export interface FlatNode {
  level: number;
  expandable: boolean;
  name: string;
}
